import "./StatusChip.css";

/**
 * Small pill for a status or tag (Pending, Completed, Present, Absent…).
 * tone: primary | link | accent | success | danger | warning | info | brand | secondary
 * icon: optional icon element shown before the label
 */
const StatusChip = ({ tone = "secondary", children, icon }) => (
  <span className="status-chip" data-tone={tone}>
    {icon}
    {children}
  </span>
);

export default StatusChip;
